package one.healthium.update_food_preferences.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class FoodPreferencesCategoryDto(
    @SerialName("id") val id: String,
    @SerialName("description") val description: String,
    @SerialName("selecting_values") val availableStatuses: List<String>,
    @SerialName("options") val answers: List<FoodPreferenceItemDto>,
)